import React from "react"
import styled from "styled-components"
import Counter from "../atoms/counter"
import media from "styled-media-query"
import CounterText from "../atoms/counter-text"

const Wrap = styled.div<{ isAnswer?: boolean }>`
  border-bottom: ${props => (props.isAnswer ? "" : "solid 1px #f4f4f4")};
  display: flex;
  justify-content: space-between;
`
const StyledH1 = styled.h1`
  color: #0145a2;
  font-family: "Teko", sans-serif;
  font-weight: 600;
  height: 44px;
  font-size: 12px;
  letter-spacing: 1.8px;
  margin: 0 0 0 -1.5px;
  ${media.greaterThan("small")`
    font-size: 16px;
    height: 60px;
    letter-spacing: 3.2px;
    margin: 5px 0 0 0;
  `}
`
const StyledSpan1 = styled.span`
  border-bottom: solid 1px #0145a2;
  display: inline-block;
  font-size: 3em;
  height: 44px;
  ${media.greaterThan("small")`
    height: 60px;
  `}
`
const StyledSpan2 = styled.span`
  font-size: 2em;
  ${media.greaterThan("small")`
    font-size: 40px;
  `}
`
const StyledSpan3 = styled.span`
  font-size: 1.67em;
  letter-spacing: 0px;
  ${media.greaterThan("small")`
    font-size: 32px;
  `}
`
const StyledSpan4 = styled.span`
  font-size: 2.67em;
  ${media.greaterThan("small")`
    font-size: 48px;
  `}
`

const QHeader = props => {
  const no = props.index + 1
  return (
    <Wrap isAnswer={props.isAnswer}>
      <StyledH1>
        <StyledSpan1>Q</StyledSpan1>
        <StyledSpan2>uestion</StyledSpan2>
        <StyledSpan3>.</StyledSpan3>
        <StyledSpan4>{no}</StyledSpan4>
      </StyledH1>
      <Counter>
        <CounterText>{no}/10</CounterText>
      </Counter>
    </Wrap>
  )
}

export default QHeader
